import cn from 'classnames';
import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@app/hooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CounterButton } from '@components/counter-button';
import { modelsActions } from '@modules/models';
import { modelsPageActions, selectModelIds } from '@modules/models-page';
import { quotationActions, selectWidgetModelId } from '@modules/quotation';
import { useBuildLocation } from '@hooks';
import { getNodeIdComposer } from '@utils';
import { useGetOrderUrl } from '@pages/widget/order/hooks';
import { RootPrefix } from './constants';

import styles from './models-page-footer.module.scss';

const _id = getNodeIdComposer(RootPrefix, 'footer');

export const ModelsPageFooter: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [getOrderUrl] = useGetOrderUrl();
    const orderLocation = useBuildLocation({
        to: getOrderUrl(),
    });
    const selectedModelIds = useAppSelector(selectModelIds);

    const quote = useCallback(() => {
        const ids = selectedModelIds.map(id => parseInt(id));
        dispatch(modelsActions.addSelectedModels(ids));
        dispatch(quotationActions.suggestModel(ids[0]));
        dispatch(modelsPageActions.selectedIdsChanged([]));
        navigate(orderLocation.to);
    }, [dispatch, navigate, orderLocation.to, selectedModelIds]);

    const count = selectedModelIds.length.toString();
    const isQuoteDisabled = !Boolean(selectedModelIds.length);

    const { t } = useTranslation();

    return (
        <div className={cn('base-paddings', 'no-top', styles.box)}>
            <CounterButton id={_id('quote')} count={count} onClick={quote} disabled={isQuoteDisabled}>
                {t('buttons.quote', 'Quote')}
            </CounterButton>
        </div>
    );
};
